import type React from 'react';
import type { LucideProps } from 'lucide-react';

const DashboardIcon: React.FC<LucideProps> = ({ size = 20, className }) => (
  <img
    src="/icons/ferraro_bench.svg"
    alt=""
    width={size}
    height={size}
    className={className}
  />
);

export default DashboardIcon;
